import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { ExpenseThisMonthInsightsEntity } from "../entities/ExpenseThisMonthInsightsEntity";

export class GetExpenseThisMonthInsightsUseCase {
  constructor(private repository: ClientOverviewRepository) {}

  async execute(): Promise<ExpenseThisMonthInsightsEntity> {
    return this.repository.getExpenseThisMonthInsights();
  }
}

